import { sharedProfileIdentity } from "../../shared/profileIdentity";

// Generated by GitHub Copilot
const profileFallback = {
  identity: {
    name: "(Venkat Sampath Siva) Ram Prakash Dhulipudi | dragon",
    pronouns: "He/Him",
    avatarUrl: "",
    headline: sharedProfileIdentity.headline,
    roles: ["Data Scientist", "ML Engineer", "React Architect", "GenAI Builder"],
    location: sharedProfileIdentity.location,
    summary:
      "I build production AI systems and scalable frontend platforms with a strong focus on trust, observability, and shipping velocity.",
    interests: sharedProfileIdentity.interests,
  },
  contact: {
    mobile: "+91-8688244266",
    email: "ramprakashdhulipudi@gmail.com",
    linkedin: "https://www.linkedin.com/in/ramprakashdhulipudi/",
    medium: "https://medium.com/@RamPrakashD",
    github: "https://github.com/Ramdragneel01",
  },
  topSkills: [
    { name: "Python", level: 95 },
    { name: "Machine Learning", level: 94 },
    { name: "Artificial Intelligence", level: 93 },
    { name: "React", level: 91 },
    { name: "MERN Stack", level: 89 },
    { name: "AWS", level: 88 },
    { name: "GitHub", level: 87 },
    { name: "Docker Desktop", level: 86 },
  ],
  skills: [
    "Python",
    "Machine Learning",
    "Artificial Intelligence",
    "GCP Professional Machine Learning Engineer",
    "GitHub",
    "GitLab",
    "GitHub Copilot",
    "MERN Stack",
    "Computer Vision",
    "Deep Learning",
    "YOLOv3",
    "Prompt Engineering",
    "AWS",
    "Web Technologies",
    "Oracle Database",
    "DBMS",
    "Operating Systems",
    "Data Structures",
    "Statistical Data Analysis",
    "Object-Oriented Programming",
  ],
  languages: [
    { name: "English", proficiency: "Full Professional" },
    { name: "Telugu", proficiency: "Native or Bilingual" },
    { name: "Tamil", proficiency: "Limited Working" },
    { name: "Hindi", proficiency: "Limited Working" },
    { name: "French", proficiency: "Elementary" },
  ],
  certifications: [
    "Professional Machine Learning Engineer Certification - Google (Issued Apr 2025, Expires Apr 2027)",
    "Intelligent Search Technical Expert Badge - Google (Issued Jul 2025)",
    "Create media search and media recommendations applications with AI Applications - Google",
    "Extend Agentspace assistant capabilities - Google",
    "Configure AI Applications to optimize search results - Google",
    "Create and maintain Vertex AI Search data stores - Google",
    "Build search and recommendations applications with AI Applications - Google",
    "Discover Business Value for Customers - Google",
    "Deliver Effective Product Demos - Google",
    "FY25 Copilot Hackathon Participant - Microsoft",
    "PRINCE2 Project Management Overview (2017 Update) - Skillsoft",
    "Certified Secure Software Lifecycle Professional (CSSLP) 2019: Secure Coding Practices - Skillsoft",
    "Agile Best Practices for Tech Leaders: Scrum Artifacts - Skillsoft",
    "Software Design and Development: Software Engineering and SDLC Phases - Skillsoft",
    "Using Robots and RPA in the Workplace - Skillsoft",
    "A10 and A9: API and Component Attacks - Skillsoft",
    "A8 and A3: Cross-Site Attacks - Skillsoft",
    "OWASP Overview - Skillsoft",
    "Communication with Client / Client Centricity - Accenture",
    "Critical Thinking - Accenture",
    "Ethics, Integrity, and Trust - Accenture",
    "Design Thinking - Accenture",
    "Mindful at Work - Accenture",
    "AI For Everyone - DeepLearning.AI",
    "The Art of Prompt Engineering - IBM Skills Network",
    "MTA: Introduction to Programming Using Python - Microsoft",
  ],
  volunteerExperience: [
    {
      role: "AI Innovation and Hackathon Contributor",
      organization: "Accenture",
      period: "Jan 2025 - May 2025",
      highlights: [
        "Participated in Microsoft Copilot Hackathon and Google Agentathon for real-world AI automation use cases.",
        "Built Copilot API-assisted productivity workflows and explored autonomous decision-capable AI agent patterns.",
        "Received badges and recognition for active contribution, creativity, and practical execution.",
      ],
    },
  ],
  hackathons: [
    {
      name: "Microsoft Copilot Hackathon",
      period: "2025",
      achievement: "Built productivity-focused AI workflow ideas using Microsoft 365 Copilot APIs.",
    },
    {
      name: "Google Agentathon",
      period: "2025",
      achievement: "Designed autonomous workflow optimization concepts using Google AI agent tooling.",
    },
  ],
  linkedinProjects: [
    {
      title: "NoTouch / OSCAR / AOAS - Accenture One AI Suite",
      organization: "Accenture",
      period: "2024 - Present",
      description:
        "Driving frontend delivery toward MVP with a config-driven UI architecture and reusable React component libraries.",
    },
    {
      title: "GenWizard AiOps - AI Observability",
      organization: "Accenture",
      period: "2024 - Present",
      description:
        "Built interactive dashboards with React and Next.js to monitor model performance, usage, and observability signals.",
    },
    {
      title: "I&F GenAI - LLM-based AI Chatbot",
      organization: "Accenture",
      period: "2024 - Present",
      description:
        "Developed LLM chatbot capabilities with Python-backed integrations for contextual responses and system optimization.",
    },
  ],
  experience: [
    {
      company: "Medium",
      role: "Freelance Writer",
      period: "Nov 2025 - Present",
      highlights: [
        "Publish content on ML, LLM systems, MLOps, and AI observability for practical engineering audiences.",
        "Translate production architecture lessons into actionable implementation guidance.",
        "Share insights from cross-functional AI product development and deployment experiences.",
      ],
    },
    {
      company: "Accenture",
      role: "Packaged App Development",
      period: "Apr 2024 - Present",
      highlights: [
        "Contributing to R&D in Accenture Product Platform with multiplatform frontend development across AI-driven products.",
        "Migrating React.js applications to Next.js for improved scalability, maintainability, and performance.",
        "Designing config-driven UI architecture and reusable component libraries for standardized module delivery.",
        "Building AI observability dashboards to monitor model behavior and improve stakeholder visibility.",
        "Contributing to LLM chatbot integrations and Python-based backend logic for improved response quality.",
      ],
    },
    {
      company: "Infyleads",
      role: "Research and Development Specialist",
      period: "Sep 2023 - Apr 2024",
      highlights: [
        "Developed and designed websites for Live Eco Kart and World Startup News with responsive UX.",
        "Led frontend implementation with modern web technologies for engaging and performance-aware interfaces.",
      ],
    },
    {
      company: "Infyleads",
      role: "Research and Development Engineer",
      period: "Jan 2023 - Sep 2023",
      highlights: [
        "Contributed content and technical implementation aligned with product direction and business goals.",
        "Collaborated with cross-functional teams to optimize usability, clarity, and delivery timelines.",
      ],
    },
    {
      company: "iVIS",
      role: "Research and Development Intern",
      period: "Feb 2022 - Apr 2022",
      highlights: [
        "Developed deep-learning object-tracking models with Deep SORT-based ID maintenance across frames.",
        "Worked with private surveillance datasets using Python, computer vision pipelines, CNN, and DNN techniques.",
      ],
    },
  ],
  education: [
    {
      institution: "Sri Chandrasekharendra Saraswathi Vishwa Mahavidyalaya, Kancheepuram",
      degree: "Bachelor of Engineering, Computer Science",
      score: "CGPA 9.17",
    },
  ],
  testScores: [
    {
      name: "Test of English as a Foreign Language",
      score: "95",
      date: "Oct 2024",
    },
    {
      name: "Graduate Record Examination",
      score: "324",
      date: "Sep 2024",
    },
  ],
  github: {
    profile: {
      username: "Ramdragneel01",
      avatarUrl: "",
      followers: 0,
      following: 0,
      publicRepos: 27,
      bio: "",
      profileUrl: "https://github.com/Ramdragneel01",
    },
    repos: [
      {
        id: "fallback-github-1",
        title: "dragon-portfolio",
        description: "Cinematic portfolio with production-ready frontend, backend APIs, and GitHub Pages deployment.",
        readmeSummary: "",
        github: "https://github.com/Ramdragneel01/dragon-portfolio",
        tags: ["React", "Vite", "Node.js", "Express"],
        stars: 0,
        forks: 0,
        updatedAt: "",
      },
      {
        id: "fallback-github-2",
        title: "hallucination-lens",
        description: "AI observability tooling focused on detecting, explaining, and reducing model hallucinations.",
        readmeSummary: "",
        github: "https://github.com/Ramdragneel01/hallucination-lens",
        tags: ["Python", "FastAPI", "ML", "Observability"],
        stars: 0,
        forks: 0,
        updatedAt: "",
      },
      {
        id: "fallback-github-3",
        title: "agentic-research-assistant",
        description: "Multi-agent research assistant for search, summarization, and critic review workflows.",
        readmeSummary: "",
        github: "https://github.com/Ramdragneel01/agentic-research-assistant",
        tags: ["Python", "Agents", "LLM", "RAG"],
        stars: 0,
        forks: 0,
        updatedAt: "",
      },
      {
        id: "fallback-github-4",
        title: "mlops-sentinel",
        description: "MLOps platform components for monitoring pipelines, model quality, and operational health.",
        readmeSummary: "",
        github: "https://github.com/Ramdragneel01/mlops-sentinel",
        tags: ["MLOps", "Monitoring", "Python", "Docker"],
        stars: 0,
        forks: 0,
        updatedAt: "",
      },
      {
        id: "fallback-github-5",
        title: "speech-emotion-v2",
        description: "Speech emotion recognition project with model evaluation and deployment-ready assets.",
        readmeSummary: "",
        github: "https://github.com/Ramdragneel01/speech-emotion-v2",
        tags: ["Audio ML", "Python", "Classification"],
        stars: 0,
        forks: 0,
        updatedAt: "",
      },
      {
        id: "fallback-github-6",
        title: "context-watchdog",
        description: "Context quality watchdog to evaluate drift, trace retrieval quality, and reporting health.",
        readmeSummary: "",
        github: "https://github.com/Ramdragneel01/context-watchdog",
        tags: ["Python", "Evaluation", "LLM"],
        stars: 0,
        forks: 0,
        updatedAt: "",
      },
      {
        id: "fallback-github-7",
        title: "astramesh-command-deck",
        description: "Command-deck style monorepo for agent tooling, orchestration, and developer workflows.",
        readmeSummary: "",
        github: "https://github.com/Ramdragneel01/astramesh-command-deck",
        tags: ["TypeScript", "Monorepo", "Agents"],
        stars: 0,
        forks: 0,
        updatedAt: "",
      },
      {
        id: "fallback-github-8",
        title: "agentic-ui",
        description: "Reusable UI component toolkit and integration layer for agentic web applications.",
        readmeSummary: "",
        github: "https://github.com/Ramdragneel01/agentic-ui",
        tags: ["TypeScript", "UI", "Storybook"],
        stars: 0,
        forks: 0,
        updatedAt: "",
      },
      {
        id: "fallback-github-9",
        title: "drift-watch",
        description: "Monitoring utilities for model and data drift detection with actionable diagnostics.",
        readmeSummary: "",
        github: "https://github.com/Ramdragneel01/drift-watch",
        tags: ["Python", "Monitoring", "MLOps"],
        stars: 0,
        forks: 0,
        updatedAt: "",
      },
      {
        id: "fallback-github-10",
        title: "llm-judge",
        description: "Evaluation tooling for LLM outputs with scoring, rubric checks, and report generation.",
        readmeSummary: "",
        github: "https://github.com/Ramdragneel01/llm-judge",
        tags: ["Python", "LLM", "Evaluation"],
        stars: 0,
        forks: 0,
        updatedAt: "",
      },
      {
        id: "fallback-github-11",
        title: "ragbench",
        description: "Benchmark suite for retrieval-augmented generation quality, latency, and consistency.",
        readmeSummary: "",
        github: "https://github.com/Ramdragneel01/ragbench",
        tags: ["RAG", "Benchmarks", "Python"],
        stars: 0,
        forks: 0,
        updatedAt: "",
      },
      {
        id: "fallback-github-12",
        title: "prompt-ops",
        description: "Prompt operations patterns for versioning, testing, and release governance in AI systems.",
        readmeSummary: "",
        github: "https://github.com/Ramdragneel01/prompt-ops",
        tags: ["Prompt Engineering", "Ops", "LLM"],
        stars: 0,
        forks: 0,
        updatedAt: "",
      },
      {
        id: "fallback-github-13",
        title: "neuralscope",
        description: "Model behavior inspection toolkit for observing neural output patterns and quality trends.",
        readmeSummary: "",
        github: "https://github.com/Ramdragneel01/neuralscope",
        tags: ["Python", "ML", "Observability"],
        stars: 0,
        forks: 0,
        updatedAt: "",
      },
      {
        id: "fallback-github-14",
        title: "config-forge",
        description: "Configuration management utilities for multi-environment platform delivery pipelines.",
        readmeSummary: "",
        github: "https://github.com/Ramdragneel01/config-forge",
        tags: ["Config", "Platform", "DevOps"],
        stars: 0,
        forks: 0,
        updatedAt: "",
      },
      {
        id: "fallback-github-15",
        title: "interview-os",
        description: "Structured interview preparation workspace with reusable prompts and assessment flows.",
        readmeSummary: "",
        github: "https://github.com/Ramdragneel01/interview-os",
        tags: ["TypeScript", "Education", "Workflow"],
        stars: 0,
        forks: 0,
        updatedAt: "",
      },
      {
        id: "fallback-github-16",
        title: "agent-tracer",
        description: "Tracing and observability framework for agent execution paths and decision events.",
        readmeSummary: "",
        github: "https://github.com/Ramdragneel01/agent-tracer",
        tags: ["Python", "Tracing", "Agents"],
        stars: 0,
        forks: 0,
        updatedAt: "",
      },
      {
        id: "fallback-github-17",
        title: "automated-ml-prediction-annotation-system",
        description: "ML recommendation and annotation acceleration platform for CV pipelines.",
        readmeSummary: "",
        github: "https://github.com/Ramdragneel01/automated-ml-prediction-annotation-system",
        tags: ["Python", "MLOps", "Computer Vision"],
        stars: 0,
        forks: 0,
        updatedAt: "",
      },
      {
        id: "fallback-github-18",
        title: "autonomous-workflow-optimization-agents",
        description: "Agent-based workflow optimization platform with orchestration and decision routing.",
        readmeSummary: "",
        github: "https://github.com/Ramdragneel01/autonomous-workflow-optimization-agents",
        tags: ["Agents", "Automation", "Python"],
        stars: 0,
        forks: 0,
        updatedAt: "",
      },
      {
        id: "fallback-github-19",
        title: "generative-ai-domain-nlp-solution",
        description: "Domain-focused NLP pipeline for generative AI use cases with reproducible experimentation.",
        readmeSummary: "",
        github: "https://github.com/Ramdragneel01/generative-ai-domain-nlp-solution",
        tags: ["Generative AI", "NLP", "Python"],
        stars: 0,
        forks: 0,
        updatedAt: "",
      },
      {
        id: "fallback-github-20",
        title: "partner-portal-microfrontends",
        description: "Enterprise portal built with federated micro-frontend modules and release governance.",
        readmeSummary: "",
        github: "https://github.com/Ramdragneel01/partner-portal-microfrontends",
        tags: ["React", "Micro-Frontend", "Enterprise"],
        stars: 0,
        forks: 0,
        updatedAt: "",
      },
      {
        id: "fallback-github-21",
        title: "object-detection-audio-feedback-assistive",
        description: "Assistive vision project for object detection and audio feedback on constrained devices.",
        readmeSummary: "",
        github: "https://github.com/Ramdragneel01/object-detection-audio-feedback-assistive",
        tags: ["Computer Vision", "Assistive AI", "Python"],
        stars: 0,
        forks: 0,
        updatedAt: "",
      },
      {
        id: "fallback-github-22",
        title: "pizzeria-fullstack-ordering-platform",
        description: "Full-stack ordering platform with custom flows and modular service architecture.",
        readmeSummary: "",
        github: "https://github.com/Ramdragneel01/pizzeria-fullstack-ordering-platform",
        tags: ["MERN", "Full Stack", "Node.js"],
        stars: 0,
        forks: 0,
        updatedAt: "",
      },
      {
        id: "fallback-github-23",
        title: "speech-emotion-recognition-ml",
        description: "Speech emotion recognition baselines with feature engineering and classifier evaluation.",
        readmeSummary: "",
        github: "https://github.com/Ramdragneel01/speech-emotion-recognition-ml",
        tags: ["Audio ML", "Python", "Classification"],
        stars: 0,
        forks: 0,
        updatedAt: "",
      },
      {
        id: "fallback-github-24",
        title: "credit-card-usage-analysis-prediction",
        description: "Behavior analytics and prediction workflows for credit-card usage intelligence.",
        readmeSummary: "",
        github: "https://github.com/Ramdragneel01/credit-card-usage-analysis-prediction",
        tags: ["Machine Learning", "Analytics", "Python"],
        stars: 0,
        forks: 0,
        updatedAt: "",
      },
      {
        id: "fallback-github-25",
        title: "ramdragneel01.github.io",
        description: "GitHub Pages root repository for portfolio hosting and public site routing.",
        readmeSummary: "",
        github: "https://github.com/Ramdragneel01/ramdragneel01.github.io",
        tags: ["GitHub Pages", "Web", "Portfolio"],
        stars: 0,
        forks: 0,
        updatedAt: "",
      },
      {
        id: "fallback-github-26",
        title: "langchain",
        description: "Fork used for external contribution workflows, issue fixes, and patch validation against upstream LangChain.",
        readmeSummary: "",
        github: "https://github.com/Ramdragneel01/langchain",
        tags: ["Python", "LangChain", "Open Source"],
        stars: 0,
        forks: 0,
        updatedAt: "",
      },
      {
        id: "fallback-github-27",
        title: "Ramdragneel01",
        description: "Profile README repository for publishing account-level positioning, roadmap, and proof-of-work links.",
        readmeSummary: "",
        github: "https://github.com/Ramdragneel01/Ramdragneel01",
        tags: ["GitHub Profile", "README", "Portfolio"],
        stars: 0,
        forks: 0,
        updatedAt: "",
      },
    ],
  },
  medium: {
    username: "RamPrakashD",
    profileUrl: "https://medium.com/@RamPrakashD",
    articles: [],
    fallbackArticles: [
      {
        id: "fallback-medium-1",
        title: "Applied AI System Design Notes",
        link: "https://medium.com/@RamPrakashD",
        excerpt: "Practical observations from building AI systems with production constraints and user impact.",
      },
      {
        id: "fallback-medium-2",
        title: "LLM Reliability and Evaluation",
        link: "https://medium.com/@RamPrakashD",
        excerpt: "Insights on faithfulness checks, guardrails, and evaluation loops in real-world AI products.",
      },
      {
        id: "fallback-medium-3",
        title: "MLOps and Observability Patterns",
        link: "https://medium.com/@RamPrakashD",
        excerpt: "Monitoring and model quality practices learned while shipping ML features.",
      },
      {
        id: "fallback-medium-4",
        title: "Frontend for Data and AI Products",
        link: "https://medium.com/@RamPrakashD",
        excerpt: "Design and implementation notes for responsive interfaces around model-backed workflows.",
      },
      {
        id: "fallback-medium-5",
        title: "Cloud Deployment Learnings",
        link: "https://medium.com/@RamPrakashD",
        excerpt: "Lessons from deploying analytics and AI workloads in cloud-native environments.",
      },
    ],
    totalArticles: 10,
  },
  updatedAt: "",
};

export default profileFallback;
